import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface StorageAllocationResource
    extends ng.resource.IResourceClass<ng.resource.IResource<null>> {
    startAllocation: ng.resource.IResourceMethod<ng.resource.IResource<null>>;
    bidAllocatedQuantity: ng.resource.IResourceMethod<
        ng.resource.IResource<null>
    >;
}

function storageAllocationResource(
    $resource: ng.resource.IResourceService
): StorageAllocationResource {
    return <StorageAllocationResource>$resource(
        config.monolithApi + '/storage-offer/:id',
        { id: '@id' },
        {
            startAllocation: {
                method: 'POST',
                url:
                    config.monolithApi +
                    '/storage-allocation/:id/allocation-start'
            },
            bidAllocatedQuantity: {
                method: 'PUT',
                url:
                    config.monolithApi +
                    '/storage-allocation/:id/bid-allocated-quantity'
            }
        }
    );
}

angular
    .module('app')
    .factory('storageAllocationResource', storageAllocationResource);
